import { defineMessages } from 'react-intl';

export default defineMessages({
  capacityFilterOverlay: {
    id: 'capacityFilterOverlay.title',
    description: 'label text visible on the capacity chip filter overlay',
    defaultMessage: 'Number of people'
  },

  capacityFilterOverlayApply: {
    id: 'capacityFilterOverlay.apply',
    description: 'apply button text',
    defaultMessage: 'Apply'
  },

  capacityFilterOverlayClear: {
    id: 'capacityFilterOverlay.clear',
    description: 'clear button text',
    defaultMessage: 'Clear'
  },

  capacityFilterChipLabelSingular: {
    id: 'capacityFilterChipLabel.singular',
    description: 'singular version of dynamic chip label',
    defaultMessage: 'person'
  },

  capacityFilterChipLabelPlural: {
    id: 'capacityFilterChipLabel.plural',
    description: 'plural version of dynamic chip label',
    defaultMessage: 'people'
  },

  capacityFilterChipAriaLabel: {
    id: 'capacityFilterChipLabel.ariaLabel',
    description: 'aria label for capacity chip',
    defaultMessage: 'Open number of people input'
  },

  capacityFilterChipAriaLabelInput: {
    id: 'capacityFilterChipLabel.ariaLabelInput',
    description: 'aria label for capacity chip input',
    defaultMessage: 'Number of People'
  },

  datePickerAriaLabel: {
    id: 'datePicker.ariaLabel',
    description: 'aria label for date picker',
    defaultMessage: 'Open date selector'
  },

  datePickerAriaLabelForInput: {
    id: 'datePicker.ariaLabelInput',
    description: 'aria label for date picker input',
    defaultMessage: 'Desired date'
  }
});
